import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouthouston() {
  return (
    <section className="about_houston tekrevol_dark_bg max_miami p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Mobile App Development in San Francisco?
            </h2>
            <p>
              Choosing Tekrevol for app development in San Francisco can be a
              beneficial decision for a business that seeks digital growth. We
              excel in innovation, client-centric solutions, and proven
              expertise, ensuring your project's success from start to finish.
              Our extensive track record demonstrates top-tier mobile
              applications that have garnered recognition and success within the
              industry. Here are the crucial reasons why you should choose us
            </p>
            <ul>
              <li>Leading the way in mobile technology trends</li>
              <li>Utilizing the latest tools and frameworks</li>
              <li>Developing tech-driven and future-ready applications</li>
              <li>Agile development approach for swift iterations</li>
              <li>Timely results and adaptability to evolving requirements</li>
            </ul>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Collaborate with Us
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-lg-auto mt-md-0"
          >
            <div className="maximize_miami_img">
              <StaticImage
                src="../../images/location_new/san-francisco/why_choose_san_1.webp"
                alt="app developers San Francisco"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={907}
                height={841}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouthouston;
